module.exports = __webpack_public_path__ + "static/media/wilson-tsai@3x.e17ab8c5.png";